import angular from 'angular';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { UserService } from '../../tn.user/service.tn.user';
import { CartService } from '../service.tn.cart';
import saveCartLoginTemplate from './login.html';
import saveCartTemplate from './save-cart.html';
import saveCartSuccessTemplate from './success.html';
import { dirtyfields } from '../../tn.common';

export function populateSaveCartTemplateCache($templateCache) {
    $templateCache.put('save-cart.view/login.html', saveCartLoginTemplate);
    $templateCache.put('save-cart.view/save-cart.html', saveCartTemplate);
    $templateCache.put('save-cart.view/success.html', saveCartSuccessTemplate);
}
populateSaveCartTemplateCache.$inject = ['$templateCache'];

SaveCartController.$inject = [
    'tn.cart.service',
    'tn.user.service',
    '$localStorage',
    '$tnPopover',
];

export function SaveCartController(
    cartService: CartService,
    userService: UserService,
    $localStorage,
    $tnPopover: PopoverService
) {
    const vm = angular.extend(this, {
        popoverTitle: '',
        successMessage: '',
        loginMessage: '',
        states: {
            login: {
                templateUrl: 'save-cart.view/login.html',
            },
            'save-cart': {
                templateUrl: 'save-cart.view/save-cart.html',
            },
            success: {
                templateUrl: 'save-cart.view/success.html',
            },
        },
        currentState: 'login',
        errors: {},
        savedCart: null,

        initialize: initialize,
        signin: signin,
        save: save,
        showRegisterOverlay: showRegisterOverlay,
        hide,
    });

    initialize();

    function initialize() {
        vm.title = '';
        vm.savedCart = null;
        vm.popoverTitle = 'Save this shopping cart';
        vm.successMessage = 'Cart Saved';
        vm.loginMessage =
            'You must be signed in to your account to save a shopping cart.';

        if (userService.isLoggedIn()) {
            vm.currentState = 'save-cart';
        } else {
            vm.currentState = 'login';
        }
    }

    function showRegisterOverlay() {
        const signinModal = angular.element('.sign_in_modal ');
        const signinModalScope = signinModal.scope();
        signinModalScope.vm['modalState'] = 'signUp';
        signinModal.addClass('is_active');
    }

    function signin() {
        return userService.oauthLogin();
    }

    function save() {
        let currentSavedCart = null;
        if (vm.saveForm.$valid) {
            currentSavedCart = $localStorage.currentSavedCart;
            return cartService
                .saveCartToServer(vm.title, currentSavedCart)
                .then(function (savedCart) {
                    vm.savedCart = savedCart;
                    vm.currentState = 'success';
                    $localStorage.currentSavedCart = null;
                });
        } else {
            dirtyfields(vm.saveForm);
        }
    }

    function hide() {
        $tnPopover.hide();
    }

    userService.login$.subscribe(() => {
        vm.currentState = 'save-cart';
    });

    userService.logout$.subscribe(() => {
        vm.currentState = 'login';
    });
}
